import React, { useState, memo } from 'react';
import CoverLetterPreviewSVG from '../preview/CoverLetterPreviewSVG';

const CoverLetterCard = memo(({ template, isActive, onClick, globalAccent, T }) => {
  const [hovered, setHovered] = useState(false);
  const accent = globalAccent || '#7C3AED';

  return (
    <div
      className="tg-card"
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        cursor: 'pointer',
        borderRadius: 16,
        overflow: 'hidden',
        position: 'relative',
        background: isActive ? T.cardActiveBg : hovered ? T.cardHoverBg : T.cardBg,
        border: `1.5px solid ${isActive ? accent : hovered ? T.borderHover : T.borderCard}`,
        boxShadow: isActive
          ? `0 0 0 1px ${accent}22, 0 8px 32px ${accent}18, ${T.hoverShadow}`
          : hovered ? T.hoverShadow : T.cardShadow,
      }}
    >
      <div style={{
        margin: '10px 10px 0',
        borderRadius: 10,
        overflow: 'hidden',
        background: 'white',
        boxShadow: T.previewShadow + ', inset 0 0 0 0.5px rgba(0,0,0,0.07)',
        aspectRatio: '210/250', // Shorter aspect ratio to reduce card height
        position: 'relative',
      }}>
        <CoverLetterPreviewSVG templateId={template.id} accent={accent} />

        <div className="tg-hover-overlay" style={{
          position: 'absolute',
          inset: 0,
          opacity: 0,
          background: 'linear-gradient(to top, rgba(0,0,0,0.5) 0%, transparent 55%)',
          transition: 'opacity 0.2s',
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'center',
          paddingBottom: 10,
        }}>
          <span style={{
            fontSize: '9px',
            fontWeight: 700,
            color: 'white',
            background: 'rgba(0,0,0,0.4)',
            backdropFilter: 'blur(8px)',
            padding: '4px 14px',
            borderRadius: 20,
            border: '1px solid rgba(255,255,255,0.2)',
          }}>Click to Use</span>
        </div>

        {isActive && (
          <div style={{
            position: 'absolute',
            top: 8,
            right: 8,
            width: 24,
            height: 24,
            borderRadius: '50%',
            background: accent,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: `0 2px 10px ${accent}90`,
          }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
              <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
            </svg>
          </div>
        )}
      </div>

      <div style={{ padding: '10px 12px 14px', display: 'flex', flexDirection: 'column', gap: 7 }}>
        <h3 style={{
          fontSize: '11.5px',
          fontWeight: 800,
          margin: 0,
          lineHeight: 1.25,
          letterSpacing: '-0.2px',
          color: isActive ? accent : T.textPrimary,
        }}>{template.label}</h3>
        <p style={{
          fontSize: '9px',
          color: T.textDesc,
          margin: 0,
          lineHeight: 1.45,
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}>{template.description}</p>
      </div>
    </div>
  );
});

export default CoverLetterCard;
